import axios from 'axios';
import { clearAuthData } from './auth';

const BLOCK_MANAGER_URL = import.meta.env.VITE_BLOCK_MANAGER_URL;

const blockManagerClient = axios.create({
    baseURL: BLOCK_MANAGER_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

blockManagerClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

blockManagerClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            clearAuthData();
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default blockManagerClient;
